import { Component, input } from "@angular/core";
import { ResetPasswordComponent } from "../reset-password/reset-password.component";
import { AppState } from "src/app/ngrx/reducers";
import { Store } from "@ngrx/store";
import { SettingsActions } from "src/app/ngrx/actions";
import { SettingsSelectors } from "src/app/ngrx/selectors";

@Component({
  selector: "app-reset-password-page",
  imports: [ResetPasswordComponent],
  templateUrl: "./reset-password-page.component.html",
  styles: ``,
})
export class ResetPasswordPageComponent {
  key = input<string>(); // will be set via the route params

  isResettingPassword = this.store.selectSignal(
    SettingsSelectors.isResettingPassword,
  );

  constructor(private readonly store: Store<AppState>) {}

  resetPassword({ key, newPassword }: { key: string; newPassword: string }) {
    this.store.dispatch(
      SettingsActions.resetPassword({
        key,
        newPassword,
      }),
    );
  }
}
